import Subcategory from './subcategory/[...subcategorySlug]'
import getServerSideAPIProps from '../../../props/getServerSideAPIProps'

export const getServerSideProps = getServerSideAPIProps('/store/[storeSlug]/search')

export default Subcategory
